import { gql } from "@apollo/client";

const GET_COMMUNITY_BY_COLLECTION_ID = gql`
  query GetCommunityByCollectionPublicId($collectionPublicId: Guid!) {
    getCommunityByCollectionPublicId(collectionPublicId: $collectionPublicId) {
      name
      sendbirdId
      communityImageUrl
      coverImageName
      imageDirectory
      description
      goals
      rules
      communityBannerUrl
      communityBannerName
      communityBannerDirectory
      creatorEmail
      communityAdmins
    }
  }
`;

export default GET_COMMUNITY_BY_COLLECTION_ID;
